import IPhoneMockupImage from 'assets/images/IPhone15Mockup.png';

import { FC, Fragment, MouseEvent } from 'react';
import { useParams } from 'react-router-dom';
// Hooks
import useToggle from 'hooks/useToggle';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectFormByQuizId, selectHash } from 'store/form/formSelectors';
import { RootState } from 'store';
// Components
import { Button } from './Buttons';
import { Dialog, DialogTitle } from 'layouts/Dialog';
import QuizFrame from './QuizFrame';
// MUI
import { DialogContent, useMediaQuery } from '@material-ui/core';
// Icons
import { FaEye } from 'react-icons/fa';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import { textFromCamelToNormalCase } from 'utilities/utilities';

type Props = {
  page: string;
  pageRef?: string;
}

const QuizPagePreview:FC<Props> = ({ page, pageRef }) => {
  const { t } = useTranslation();
  const { quizId } = useParams<{ quizId:string }>();

  const isLaptop = useMediaQuery('(min-width: 1280px)');

  const quizForm:any = useAppSelector((state:RootState) => selectFormByQuizId(state, { quizId }));
  const hash:string | null = useAppSelector(selectHash);

  const onClick = (event:MouseEvent<HTMLButtonElement> | undefined) => {
    event?.stopPropagation();
    toggle();
  }

  const { open, toggle } = useToggle();

  return (
    <Fragment>
      <Button onClick={onClick} className="flex items-center gap-2">
        <FaEye />
        <span>{t('dialogs.quizPagePreview.previewButton')}</span>
      </Button>

      <Dialog size="full" open={open} onClose={toggle}>
        <DialogTitle title={t('dialogs.quizPagePreview.title', { pageType: textFromCamelToNormalCase(page) })} onClose={toggle} />
        <DialogContent className="h-full flex">
          <div className="flex-grow relative overflow-y-auto">
            <div className="absolute w-full h-full left-0 top-0">
              <div
                className="
                  flex flex-col justify-center items-center
                  relative my-4 mx-auto
                "
                style={{
                  width: 420,
                  height: 870,
                  transform: isLaptop ? 'scale(0.65) translate(-27%, -28%)' : 'none',
                }}
              >
                <div className="absolute top-0 left-0 w-full h-full" />
                <span
                  className="
                    absolute top-0 left-0 w-full h-full
                    bg-contain bg-no-repeat
                    pointer-events-none
                    z-20
                  "
                  style={{
                    backgroundImage: `url(${IPhoneMockupImage})`
                  }}
                ></span>
                {hash ? (
                  <QuizFrame
                    style={{
                      width: '93%',
                      height: '97%',
                      borderRadius: '40px'
                    }}
                    id="preview-mobile"
                    quizNameSlug={quizForm?.quizNameSlug}
                    quizHash={hash}
                    preview="quiz"
                    page={page}
                    pageRef={pageRef}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}

export default QuizPagePreview;
